/**
 * 企业整单折扣 · 商城端展示工具
 * 登录后拉取一次会员企业折扣率（缓存模块级），页面用 entPriceMixin 获得 entRate / dpEnt。
 * ⚠️ 只用于"展示"（划线原价→折后价）；下单金额由后端按同一口径权威计算。
 */
import API from '@/utils/request'

const cache = { rate: 1, deptName: '', loaded: false, loading: null, forToken: null }

export function loadEntDiscount(force) {
  const token = localStorage.getItem('token')
  // 未登录：返回无折扣但【不写缓存】，避免登录前把 rate=1 永久钉死（本次 bug 根因）
  if (!token) {
    cache.loaded = false
    cache.forToken = null
    cache.rate = 1
    return Promise.resolve(cache)
  }
  // 缓存只对"取缓存时所用的那个 token"有效：登录换账号/重新登录自动失效重拉
  if (cache.loaded && cache.forToken === token && !force) return Promise.resolve(cache)
  if (cache.loading && !force) return cache.loading
  cache.loading = API.get('/api/h5/fulfillment/memberDiscount', {
    headers: { Authorization: `Bearer ${token}` }
  }).then(res => {
    const d = (res && res.data) || {}
    cache.rate = d.discountRate ? Number(d.discountRate) : 1
    cache.deptName = d.deptName || ''
    cache.loaded = true
    cache.forToken = token
    cache.loading = null
    return cache
  }).catch(() => {
    cache.rate = 1
    cache.loaded = true
    cache.forToken = token
    cache.loading = null
    return cache
  })
  return cache.loading
}

/** 折后单价（HALF_UP 2位，与后端 setScale(2,HALF_UP) 一致） */
export function dp(price, rate) {
  const r = rate == null ? 1 : Number(rate)
  const p = Number(price || 0)
  if (!p || r >= 1) return p
  return Math.round(p * r * 100) / 100
}

export const entPriceMixin = {
  data() {
    return { entRate: 1, entDeptName: '' }
  },
  created() {
    loadEntDiscount().then(c => {
      this.entRate = c.rate
      this.entDeptName = c.deptName
    })
  },
  computed: {
    hasEntDiscount() {
      return this.entRate > 0 && this.entRate < 1
    }
  },
  methods: {
    dpEnt(price) {
      return dp(price, this.entRate)
    }
  }
}
